
export enum StatusPagamentoAcordoRenegociacaoCartaoEnum {
  ABERTO = 'ABERTO',
  CANCELADO = 'CANCELADO',
  LIQUIDADO = 'LIQUIDADO',
  PAGO = 'PAGO',
}

export interface AcordoRenegociacaoCartao {
  id: string;
  dataAcordo: string;
  idCartao: string;
  nomeProduto: string;
  valorAcordo: number;
  nome: string;
  email: string;
  parcelas: ParcelaRenegociacaoCartao[];
}

export interface StatusPagementoParcelaRenegociacaoCartao {
  value: StatusPagamentoAcordoRenegociacaoCartaoEnum;
  description: string;
}

export interface ParcelaRenegociacaoCartao {
  nrParcela: number;
  valorParcela: number;
  dataVencParcela: string;
  statusPagamento: StatusPagementoParcelaRenegociacaoCartao;
  linhaDigitavel: string;
  codigoBarras: string;
  boletoPdf: string;
}